import type { ProductCourse } from '../course';
import type { Institution } from '@/models/catalog/course';
import type { Offer } from '@/models/catalog/offer';

export enum PaymentMethod {
  Pix = 'pix',
  BankSlip = 'boleto',
  Card = 'credit_card',
}

export interface OfferCheckoutRequest {
  coupon: string;
  address: string;
  address_number: string;
  city: string;
  complement: string;
  district: string;
  document: string;
  email: string;
  home_phone: string;
  mobile_phone: string;
  name: string;
  state: string;
  subscriptionId: number;
  zip_code: string;
  paymentData: {
    number: string;
    installments: number | string;
    cvv: string;
    holder_name: string;
    amount: number | string;
    exp_month: string;
    exp_year: string;
    cpf: string;
  };
  idToken: string;
  payment_method: PaymentMethod;
}

export interface PixPaymentData {
  qr_code: string;
  qr_code_url: string;
}

export interface BankSlipPaymentData {
  url: string;
  pdf: string;
  line: string;
  barcode: string;
  qr_code: string;
}

export interface OfferCheckoutResponse {
  data: {
    orderId: number;
    paymentData: PixPaymentData | BankSlipPaymentData;
  };
}

export interface OfferCouponRequest {
  coupon: string;
}

export interface OfferCouponResponse {
  data: {
    coupon: {
      discount: number;
      code: string;
    };
    offer: OfferWithDetails;
  };
}

export interface useOfferFiltersProps {
  courseId: number;
  queryParams: string;
  enabled?: boolean;
}

export interface InstitutionSubscriptionConfig {
  link: string;
  coupon?: string;
  external_purchase_action?: boolean;
}

export interface OfferWithDetails extends Offer {
  campus: {
    campus: string;
    city: string;
    state: string;
  };
  institution: Institution;
  course: ProductCourse;
  max_installments: number;
  institution_subscription_config: InstitutionSubscriptionConfig | null;
  checkout_pricing: {
    calculated_amount: number;
    coupon_discount_amount?: number;
    original_amount: number;
    installments?: {
      amount: number;
      count: number;
    }[];
  };
}
